import * as Effects from 'redux-saga/effects'
import {
  IToggleCreateReservation,
  IToggleUpdateReservation,
} from '../../actions/bookingCalendar/reservationModal/toggleReservationModal'
import { requestPaymentDictionaries } from '../../actions/paymentDictionary/loadDictionaries'
import { ReservationModalActions } from '../../reducers/bookingCalendar/actionNames'

function* loadDictionary(
  action: IToggleUpdateReservation | IToggleCreateReservation,
) {
  if (action.toggle) {
    yield Effects.put(requestPaymentDictionaries(new Date(0)))
  }
}

export default function*() {
  yield Effects.takeLatest(
    ReservationModalActions.ToggleCreateReservationModalRedux,
    loadDictionary,
  )
  yield Effects.takeLatest(
    ReservationModalActions.ToggleUpdateReservationModalRedux,
    loadDictionary,
  )
}
